import { useState, useEffect, useCallback } from 'react';
import { APIProvider, AdvancedMarker, Map, MapControl, ControlPosition, useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

export default function MapDataOverlays({ config, ncaState, lpaState, onHover }) {
    const [dataLoaded, setDataLoaded] = useState(false);
    const map = useMap();
    const [ncaLoaded, setNcaLoaded] = useState(false);
    const [lpaLoaded, setLpaLoaded] = useState(false);

    useEffect(() => {
        if (!map || !config) return;

        if (!dataLoaded) {
            setDataLoaded(true);
            map.data.loadGeoJson('/ppi/Dataset/nca?v=1', null, function (feature) {
                if (!ncaState) {
                    feature.forEach(function (f) { f.setProperty("visible", false); });
                }
            });
            map.data.loadGeoJson('/ppi/Dataset/lpa', null, function (feature) {
                if (!lpaState) {
                    feature.forEach(function (f) { f.setProperty("visible", false); });
                }
            });

            map.data.setStyle({ fillOpacity: 0 });

            if (!lpaState && !ncaState) {
                map.data.setStyle({
                    fillOpacity: 0,
                    strokeWeight: 0
                });
            }
            else {
                map.data.setStyle(function (feature) {
                    let colour = feature.getProperty("ot") == "lpa" ? "rgb(21, 35, 89)" : "rgb(98, 103, 106)";
                    let zIndex = feature.getProperty("ot") == "lpa" ? 5 : 4;
                    return {
                        strokeColor: colour,
                        strokeWeight: 1,
                        fillOpacity: 0,
                        fillColor: colour,
                        zIndex: zIndex
                    };
                });
            }

            map.data.addListener('mouseover', function (event) {
                let visible = event.feature.getProperty("visible");
                if (visible) {
                    map.data.revertStyle(event.feature);
                    map.data.overrideStyle(event.feature, { fillOpacity: 0.4 });
                    onHover(event.feature.getProperty("name"))
                }
            });

            map.data.addListener('mouseout', function () {
                map.data.forEach(function (feature) {
                    let visible = feature.getProperty("visible");
                    if (visible) {
                        map.data.revertStyle(feature);
                    }
                    
                });
                onHover('');
            });
        }

    }, [map]);

    useEffect(() => { if (!map) return; toggleLPA(lpaState) }, [lpaState]);
    useEffect(() => { if (!map) return; toggleNCA(ncaState) }, [ncaState]);

    function toggleLPA(state) {

        if (state && !lpaLoaded) {
            map.data.setStyle(function (feature) {
                if (!ncaLoaded && feature.getProperty("ot") == "nca") {
                    return {
                        fillOpacity: 0,
                        strokeWeight: 0
                    };
                } else {
                    let colour = feature.getProperty("ot") == "lpa" ? "rgb(21, 35, 89)" : "rgb(98, 103, 106)";
                    let zIndex = feature.getProperty("ot") == "lpa" ? 5 : 4;
                    return {
                        strokeColor: colour,
                        strokeWeight: 1,
                        fillOpacity: 0,
                        fillColor: colour,
                        zIndex: zIndex
                    };
                }
            });
            setLpaLoaded(true);
        }
        map.data.forEach(function (feature) {
            if (feature.getProperty("ot") == "lpa") {
                if (!state) {
                    map.data.overrideStyle(feature, { visible: false });
                    feature.setProperty("visible", false);
                } else {
                    map.data.revertStyle(feature);
                    feature.setProperty("visible", true);
                }
            }
        });
    }

    function toggleNCA(state) {
        if (state && !ncaLoaded) {
            map.data.setStyle(function (feature) {
                if (!lpaLoaded && feature.getProperty("ot") == "lpa") {
                    return {
                        fillOpacity: 0,
                        strokeWeight: 0
                    };
                } else {
                    let colour = feature.getProperty("ot") == "lpa" ? "rgb(21, 35, 89)" : "rgb(98, 103, 106)";
                    let zIndex = feature.getProperty("ot") == "lpa" ? 5 : 4;
                    return {
                        strokeColor: colour,
                        strokeWeight: 1,
                        fillOpacity: 0,
                        fillColor: colour,
                        zIndex: zIndex
                    };
                }
            });

            setNcaLoaded(true);
        }
        map.data.forEach(function (feature) {
            if (feature.getProperty("ot") == "nca") {
                if (!state) {
                    map.data.overrideStyle(feature, { visible: false });
                    feature.setProperty("visible", false);
                } else {
                    map.data.revertStyle(feature);
                    feature.setProperty("visible", true);
                }
            }
        });
    }
}